import React from 'react'
import { User } from '../models/user';

const CurrentUserContext = React.createContext({
    User: null as (User | null),
    SetUser: (user: User) => { },
});

export const CurrentUserContextProvider = CurrentUserContext.Provider

export default CurrentUserContext
